// extracted by mini-css-extract-plugin
export default {"line_count_button":"IncDecButton_line_count_button__brpfX","button_disable":"IncDecButton_button_disable__pJUTZ","inputValue":"IncDecButton_inputValue__5YfbX"};